<template>
    <div class="uk-width-1-1">
        <span v-if="($route.params._channel !== '-1' || $route.params.exact_match === '1')" class="pbs-schedule-grid-title">{{program_details.series_title}}</span>
        <br />
        <span class="pbs-schedule-grid-sub-title"
              v-if="program_details.episode_title.length > 0
                    && program_details.series_title !== program_details.episode_title
                    && ($route.params._channel !== '-1' || $route.params.exact_match === '1')">{{program_details.episode_title}}<br /><br /></span>

        <form method="post" action="/program-reminder-process" class="form-horizontal" id="email_reminder" name="reminder_form">

            <input name="requesting_access_id" type="hidden" :value="program_details.access_id">
            <div style="margin-top: 10px;margin-left: 20px;">
                <div v-for="repeat in program_repeats" v-bind:key="repeat.access_id" class="margin-bottom-20">
                    <input :id="`time_checkbox_${repeat.access_id}`" :name="`sel-accessID_${repeat.access_id}`" type="checkbox" class="episode_selector" :checked="(repeat.access_id == program_details.access_id) ? 'checked':''" />
                    <label class="size-16" style="margin-left: 5px" :for="`time_checkbox_${repeat.access_id}`">{{repeat.text_formatted_date}}  on channel 12.{{repeat.channel_num}}</label>
                </div>
                <div v-if="program_repeats.length === 0 " class="margin-bottom-20">
                    <input :id="`time_checkbox_${program_details.access_id}`" :name="`sel-accessID_${program_details.access_id}`" type="checkbox" class="episode_selector" checked="checked" />
                    <label class="size-16" style="margin-left: 5px" :for="`time_checkbox_${program_details.access_id}`"> {{program_details.text_formatted_date}}  on channel 12.{{program_details.channel_num}}</label>
                </div>
            </div>

            <div class="form-group">
                <label class="col-sm-3 control-label" style="margin-top: 10px;">remind me </label>

                <select class="form-control input-lg" style="min-width: 300px;max-width: 300px;" name="time_ahead" size="1">
                    <option value="1440">1 day in advance</option>
                    <option value="360">6 hours in advance</option>
                    <option value="120">2 hours in advance</option>
                    <option value="60">1 hour in advance</option>
                    <option value="30" selected="">30 minutes in advance</option>
                    <option value="15">15 minutes in advance</option>
                </select>
            </div>

            <div class="form-group">
                <label class="col-sm-3 control-label">send by: </label>
                    <input type="radio" v-model="type_of_reminder" value="email" checked="checked" />
                    email&nbsp;&nbsp;or&nbsp;&nbsp;
                    <input type="radio" v-model="type_of_reminder" value="sms" name="reminderSelect" />
                    text message
                <input type="hidden" name="reminder_type" :value="(type_of_reminder === 'email') ? '1':'2'" />
            </div>

            <div v-if="type_of_reminder === 'email'">
                <div class="form-group">
                    <label class="col-sm-3 control-label">email</label>
                    <div class="col-sm-9">
                        <input type="text" name="email_addr" class="form-control input-lg" maxlength="100">
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-sm-3 control-label">message</label>
                    <div class="col-sm-9">
                        <div class="ereminder-form-field">
                            <textarea class="form-control input-lg" style="height: 100px;" name="comments" placeholder="optional"></textarea>
                        </div>
                    </div>
                </div>

                <hr />
                <div class="ereminder-submit-container text-center">
                    <input class="button-schedule button-watch-now"  type="submit" value="submit" name="submit" style="border: 0;background: white;max-width: 300px;">
                </div>
            </div>

            <div v-if="type_of_reminder === 'sms'">
                <div class="ereminder-form-label">cell or pager number:
                    <input class="form-control" style="width: 300px;" maxlength="50" name="phone_number" type="text">
                </div>
                <div class="ereminder-form-field" style="margin-top: 15px;">
                    <div class="ereminder-form-label">select carrier:
                        <select  style="width: 300px;" class="form-control margin_top_12px margin_bottom_4px" name="carrier" size="1">
                            <option value="">-select carrier-</option>
                            <option value="@message.alltel.com">Alltel - @message.alltel.com</option>
                            <option value="@txt.att.net">AT&amp;T - @txt.att.net</option>
                            <option value="@myboostmobile.com">Boost Mobile - @myboostmobile.com</option>
                            <option value="@myblue.com">Centennial Wireless - @myblue.com</option>
                            <option value="@sms.mycricket.com">Cricket - @sms.mycricket.com</option>
                            <option value="@einsteinmms.com">Einstein PCS - @einsteinmms.com</option>
                            <option value="@page.metrocall.com">Metrocall - @page.metrocall.com</option>
                            <option value="@messaging.nextel.com">Nextel - @messaging.nextel.com</option>
                            <option value="@messaging.sprintpcs.com">Sprint PCS - @messaging.sprintpcs.com</option>
                            <option value="@tmomail.net">T-Mobile - @tmomail.net</option>
                            <option value="@mms.uscc.net">US Cellular - @mms.uscc.net</option>
                            <option value="@Vtext.com">Verizon - @Vtext.com</option>
                            <option value="@vmobl.com">Virgin Mobil - @vmobl.com</option>
                            <option value="">Other</option>
                        </select>
                    </div>
                </div>

                <p>If your carrier is not listed, please enter the entire phone number +
                    email address in the box above (e.g., 303-555-1212@myphonecarrier.com).</p>

                <hr />
                <div class="ereminder-submit-container text-center" >
                    <input class="button-schedule button-watch-now" id="email_reminder_submit" type="submit" value="submit" name="submit" style="float: right;border: 0;background: white;max-width: 300px;">
                </div>
            </div>

        </form>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props:['program_details'],
    name: "ProgramReminderForm",
    computed:{
        end_point(){
            if(window.location.href.match(/localhost/)) return 'https://www.pbs12.org/schedule_rest.php?/schedule_reminder/'
            return `https://${window.location.href.split('/')[2]}/schedule_rest.php?/schedule_reminder/`
        },
    },
    data(){
        return {
            program_repeats: [],
            type_of_reminder: 'email'
        }
    },
    created() {
        if(this.program_details != undefined){
            this.fetch_program_repeats(this.program_details.episode_id)
        }
    },
    methods:{
        fetch_program_repeats(id){
            let vm = this
            axios.get(`${this.end_point}${id}`, {
                data: {},
                headers: {'Content-Type': 'application/json'}
            }).then( response => {
                vm.program_repeats = response.data
            }).catch(reason => {
                console.log('failed to get repeats data', reason)
            })
        },
        format_date(fulldate){
            const event = new Date(Date.parse(fulldate))
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
            console.log(event.toLocaleDateString('en-US', options))
            return `${event.toLocaleDateString('en-US', options)} at ${fulldate.split(/ /)[1]}`
        },
    }
}
</script>

<style scoped>

</style>